import { render, staticRenderFns } from "./HealthProfessionals.vue?vue&type=template&id=c6636fe8&"
import script from "./HealthProfessionals.vue?vue&type=script&lang=ts&"
export * from "./HealthProfessionals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports